
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#4a3428","stroke-linejoin":"round","stroke-width":"1.19047"}},[_c('g',{attrs:{"stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"m2.39941 6.66733 9.09749-3.65698 8.9115 3.28166v10.13369l-8.4688 5.2513-9.54019-5.1422z"}}),_c('path',{attrs:{"d":"m20.4084 6.29202-8.4463 4.41088-9.52411-4.00989"}}),_c('path',{attrs:{"d":"m11.9525 10.735v10.8811"}}),_c('path',{attrs:{"d":"m7.23694 4.76184 8.97886 3.71473"}})]),_c('path',{attrs:{"d":"m16.2157 8.52795v3.70515"}})])])
          )
        }
      }
    